import React from 'react'
import CardWidget, { Colors } from '../../../../components/CardWidget'
import CardWidgetSkeleton from '../../../../components/skeletons/CardWidgetSkeleton'
import { formatCurrency, formatNumber } from '../../../../utils/Helpers'

type Props = {
  multipleShoppingCartWaitingConfirmationGMV: number,
  multipleShoppingCartConfirmedGMV: number,
  multipleShoppingCartDeliveringGMV: number,
  multipleShoppingCartAvailableGMV: number,

  multipleShoppingCartWaitingConfirmationQuantity: number,
  multipleShoppingCartConfirmedQuantity: number,
  multipleShoppingCartDeliveringQuantity: number,
  multipleShoppingCartAvailableQuantity: number
}

const MultipleShoppingCartOpenGMV = ({
  multipleShoppingCartWaitingConfirmationGMV,
  multipleShoppingCartConfirmedGMV,
  multipleShoppingCartDeliveringGMV,
  multipleShoppingCartAvailableGMV,
  multipleShoppingCartWaitingConfirmationQuantity,
  multipleShoppingCartConfirmedQuantity,
  multipleShoppingCartDeliveringQuantity,
  multipleShoppingCartAvailableQuantity
}: Props): JSX.Element => {
  if (multipleShoppingCartWaitingConfirmationGMV && !multipleShoppingCartConfirmedGMV && !multipleShoppingCartDeliveringGMV && !multipleShoppingCartAvailableGMV) return <CardWidgetSkeleton />

  const totalGMV: number = multipleShoppingCartWaitingConfirmationGMV + multipleShoppingCartConfirmedGMV + multipleShoppingCartDeliveringGMV + multipleShoppingCartAvailableGMV
  const totalQuantity: number = multipleShoppingCartWaitingConfirmationQuantity + multipleShoppingCartConfirmedQuantity + multipleShoppingCartDeliveringQuantity + multipleShoppingCartAvailableQuantity

  return (
    <CardWidget title={`Pedidos em aberto (${formatNumber(totalQuantity, 0)} itens)`} number={`${formatCurrency(totalGMV)}`} color={Colors.blue} />
  )
}

export default MultipleShoppingCartOpenGMV
